import Image from '@tiptap/extension-image';
import { Plugin } from 'prosemirror-state';

import { createErrorToast } from '../../redux/modules/app';

const allowedMimeTypes = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
const MAX_IMAGE_SIZE_MB = 5;
const MAX_IMAGE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export const getCustomImagePlugin = dispatch => Image.extend({
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            drop(view, event) {
              const hasFiles = event.dataTransfer
                && event.dataTransfer.files
                && event.dataTransfer.files.length;

              if (!hasFiles) {
                return;
              }

              const images = Array.from(event.dataTransfer.files).filter(file => {
                if (!allowedMimeTypes.includes(file.type) || /image/i.test(file.type)) {
                  return false;
                }

                if (file.size > MAX_IMAGE_BYTES) {
                  dispatch(createErrorToast({ title: 'Image too large', description: `Max size is ${MAX_IMAGE_SIZE_MB}MB` }));
                  return false;
                }

                return true;
              });

              if (images.length === 0) {
                dispatch(createErrorToast({ title: 'Unsupported file type', description: 'Editor accepts png, jpeg, webp, or gif' }));

                return;
              }

              event.preventDefault();

              const { schema } = view.state;
              const coordinates = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
              });

              images.forEach(image => {
                const reader = new FileReader();

                reader.onload = readerEvent => {
                  const node = schema.nodes.image.create({ src: readerEvent.target.result });
                  const transaction = view.state.tr.insert(
                    coordinates.pos,
                    node
                  );
                  view.dispatch(transaction);
                };

                reader.readAsDataURL(image);
              });
            },
            paste(view, event) {
              const hasFiles = event.clipboardData
                && event.clipboardData.files
                && event.clipboardData.files.length;

              if (!hasFiles) {
                return;
              }

              const images = Array.from(
                event.clipboardData.files
              ).filter(file => {
                if (file.size > MAX_IMAGE_BYTES) {
                  dispatch(createErrorToast({ title: 'Image too large', description: `Max size is ${MAX_IMAGE_SIZE_MB}MB` }));
                  return false;
                }

                return allowedMimeTypes.includes(file.type) && /image/i.test(file.type);
              });

              if (images.length === 0) {
                dispatch(createErrorToast({ title: 'Unsupported file type', description: 'Editor accepts png, jpeg, webp, or gif' }));
                return;
              }

              event.preventDefault();

              const { schema } = view.state;

              images.forEach(image => {
                const reader = new FileReader();

                reader.onload = readerEvent => {
                  const node = schema.nodes.image.create({ src: readerEvent.target.result });
                  const transaction = view.state.tr.replaceSelectionWith(node);
                  view.dispatch(transaction);
                };

                reader.readAsDataURL(image);
              });
            }
          }
        }
      })
    ];
  }
});
